import { OrganizationTypeEntity } from '../entities/OrganizationType';
import { authResource } from './Auth';
export const OrganizationTypeResource = authResource({
    path: '/OrganizationTypes/:id',
    schema: OrganizationTypeEntity
});
